import { Component, OnInit, Input } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavigationExtras, Router } from '@angular/router';
import { Events,Platform,ModalController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { AdminSettingsService } from 'src/app/services/admin-settings/admin-settings.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { VendorService } from 'src/app/services/vendor/vendor.service';
import { encodeURL } from 'src/app/services/parseURL';
import { ConsoleService } from 'src/app/services/console/console.service';
import { ChatBotPage } from '../../chat-bot/chat-bot.page';


@Component({
    selector: 'app-page-footer',
    templateUrl: './page-footer.component.html',
    styleUrls: ['./page-footer.component.scss'],
})
export class PageFooterComponent implements OnInit {
    @Input() innerPage: boolean;

    categories: any[] = [];
    storeData: any = {
        allowComment: false,
        allowStoreInfo: false,
        appPackageName: "",
        appVersion: "",
        commentMsg: "",
        facebookUrl: "",
        instagramUrl: "",
        storeAddress: {
            address: "",
            city: "",
            state: "",
            stateCode: ""
        },
        storeInfo: "",
        storeName: "",
        storePhone: "",
        twitterUrl: "",
        welcomeMsg: "",
        youtubeUrl: "",
        whatsappNumber: "",
    };
    whatsappURL = "";
    currentYear;
    appData: any = {
        appPackageName: "",
        appStoreUrl: "",
        appVersion: "",
        forceUpdate: true,
        playstoreUrl: ""
    }

    showFooterLogo = true;
    policiesData: any;
    loginStatus;

    paytmActive = false;
    razorpayActive = false;
    codActive = false;
    vendorData;
    isIOS;
    faqPageData;
    brandingWebsite = false;
	numberOfActivePaymentModes = 0;

    constructor(
        private storage: Storage,
        private router: Router,
        private events: Events,
        private configService: ConfigService,
        public userService: UserService,
        private utilsService: UtilsService,
        private adminSettingsService: AdminSettingsService,
        private sharedService: SharedService,
        private vendorService:VendorService,
        private platform:Platform,
        private consoleService:ConsoleService,
        private modalController: ModalController
    ) {}

    async ngOnInit() {
        let configData = this.configService.environment;
       	this.brandingWebsite = configData.brandingWebsite;

        this.faqPageData = await this.sharedService.getFaqData();
        this.consoleService.consoleLog('page-footer.component:87 faqPageData',this.faqPageData)
        this.platform.ready().then(() => {
            this.isIOS = this.platform.is('ios');
          });

        let vendorData = await this.vendorService.getMultiVendorSettingsDataInSessionStorage();
        if(vendorData && (Object.keys(vendorData).length)){
            this.vendorData = vendorData;
        }

        this.initializeSubscriptions();
        this.showFooterLogo = environment.showFooterLogo;
        let date = new Date();
        this.currentYear = date.getFullYear();

        let userId = this.userService.getUserId();
        if (userId === '') {
            this.loginStatus = false;
        } else {
            this.loginStatus = true;
        }

    }

    ngOnDestroy() {
        this.removeSubscriptions();

    }
    removeSubscriptions() {
        this.events.unsubscribe('product:publishAllCategoriesForShop');
        this.events.unsubscribe('product:noCategoryAvailable');
        this.events.unsubscribe('admin-settings:publishTermsAndPrivacyData');
    }

    async initializeSubscriptions() {
        this.events.subscribe('auth:logoutSuccess', () => {
            this.loginStatus = false;
        })

        let storeData: any;
        storeData = await this.storage.get('storeInfo');
        console.log("initializeSubscriptions storeData", storeData);
        if(!storeData) {
            storeData = await this.adminSettingsService.getStoreInfo('return');
        }
        if (storeData) {
            this.storeData = storeData;

            if (storeData.whatsappNumber) {
                this.whatsappURL = 'https://wa.me/' + this.configService.environment.defaultCountryCode + storeData.whatsappNumber;
            }
        }
        let appData = await this.storage.get('appInfo');
        if (appData) {
            this.appData = appData;
        }

        this.events.subscribe('product:publishAllCategoriesForShop', (categories) => {
            this.categories = categories;
        });
        this.events.subscribe('product:noCategoryAvailable', () => {
        });

        this.events.subscribe('admin-settings:publishTermsAndPrivacyData', () => {
            this.storage.get('policiesData').then((result) => {
                if (result) {
                    this.policiesData = result;

                }
            });
        });


        this.events.publish('product:getAllCategoriesForShop');
        this.events.publish('admin-settings:getTermsAndPrivacyData');

        const storageCod: any = JSON.parse(sessionStorage.getItem('cod'));
        const storageRazorpay: any = JSON.parse(sessionStorage.getItem('razorpay'));
        const storagePaytm: any = JSON.parse(sessionStorage.getItem('paytm'));

        if(storageCod) {
            this.codActive = storageCod.active;
        } else {
            const paymentInfoData = await this.adminSettingsService.getPaymentInfoData('return');
            this.codActive = paymentInfoData && paymentInfoData.isCod ? true : false;
            sessionStorage.setItem('cod', JSON.stringify({active: this.codActive}) as any);
        }
        if(storageRazorpay) {
            this.razorpayActive = storageRazorpay.active;
        } else {
            const razorpayData = await this.adminSettingsService.getRazorPayData('return');
            this.razorpayActive = razorpayData && razorpayData.active ? true : false;
            sessionStorage.setItem('razorpay', JSON.stringify({active: this.razorpayActive}) as any);
        }
        if(storagePaytm) {
            this.paytmActive = storagePaytm.active;
        } else {
            const paytmData = await this.adminSettingsService.getPaytmData('return');
            this.paytmActive = paytmData && paytmData.active ? true : false;
            sessionStorage.setItem('paytm', JSON.stringify({active: this.paytmActive}) as any);
        }

		if (this.razorpayActive) {
			this.numberOfActivePaymentModes += 1;
		}
		if (this.paytmActive) {
			this.numberOfActivePaymentModes += 1;
		}
		if (this.codActive) {
			this.numberOfActivePaymentModes += 1;
		}
    }

    goToPage(page: string) {
        this.router.navigate([page]);
    }

    goToUSerPage(page: string) {
        if (this.userService.userId === '') {
            this.utilsService.openLoginModal()
        } else {
            this.router.navigate([page]);
        }
    }

    openLoginModal() {
        this.utilsService.openLoginModal();
    }


    openChat() {
        if (this.userService.userId != '') {
            this.openChatModal();
        } else {
            this.openLoginModal();
        }

    }

    async openChatModal() {
		const footer_chat_btn = document.getElementById('footer-chat-btn');

        const modal = await this.modalController.create({
            component: ChatBotPage,
            cssClass: "chat-modal",
            showBackdrop: false,
            backdropDismiss: false
        });
		modal.onDidDismiss().then(() => {
			footer_chat_btn.style.display = '';
		});
		footer_chat_btn.style.display = 'none';

        return await modal.present();

    }


}
